import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function JolliPlay() {
  const data = promotionsData.find(
    (promo) => promo.title === "JolliPlay Free Spins Code"
  )
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> JolliPlay Free Spins </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> JolliPlay Free Spins Code</h1>{" "}
                  <h2>30 Winners Daily! Grab Yours from CSR Now!</h2>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong> Promo Period: </strong>
                      <span> September 1 (12AM) - September 30 (11:59PM) </span>
                    </p>
                  </div>
                  <div className="promotion-tnc-mechanic-content">
                    <strong> Terms & Conditions </strong>{" "}
                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "0px" }}
                      >
                        <thead>
                          <th></th>
                          <th>EXISTING PLAYERS</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Availability</td>
                            <td> Everyday </td>
                          </tr>
                          <tr>
                            <td> Free Spins</td>
                            <td> 10 </td>
                          </tr>
                          <tr>
                            <td>Free Spin Value</td>
                            <td> ₱5 per spin </td>
                          </tr>
                          <tr>
                            <td>Turnover Requirement</td>
                            <td> 3x </td>
                          </tr>
                          <tr>
                            <td>Max Withdrawable Winnings</td>
                            <td> ₱200 </td>
                          </tr>
                          <tr>
                            <td>Daily & Weekly Limit</td>
                            <td> 30 Players per day </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <ol>
                      <li>
                        All FGH players are eligible to claim the coupon once
                        per account only. For new players, search{" "}
                        <strong className="highlight">"FGH"</strong> on GOOGLE
                        and register an account.
                      </li>
                      <li>
                        Only the{" "}
                        <strong className="highlight">
                          first 30 verified new and existing players
                        </strong>{" "}
                        daily may claim the coupon via Customer Support.
                      </li>
                      <li>
                        Winnings from the Free Spins have an{" "}
                        <strong className="highlight">
                          3x turnover requirement{" "}
                        </strong>
                        using the winning amount itself.
                      </li>
                      <li>
                        Once completed,{" "}
                        <strong className="highlight">
                          {" "}
                          up to ₱200 can be withdrawn
                        </strong>{" "}
                        to your wallet.
                      </li>
                      <li>Daily limit resets every 12MN.</li>
                      <li>
                        Each{" "}
                        <strong className="highlight">
                          unique player can only claim the coupon once
                        </strong>{" "}
                        during the entire promo period. Multiple claims will not
                        be honored.
                      </li>
                      <li>
                        Account{" "}
                        <strong className="highlight">
                          verification is required
                        </strong>{" "}
                        before claiming any free spins and any winnings from the
                        free spins.
                      </li>
                    </ol>
                    <strong>Qualified Games</strong>
                    <MasterGamesList
                      advantGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customAdvantGames={[
                        { provider: "jolliplay", gameName: "Mahjong Roar" },
                        {
                          provider: "jolliplay",
                          gameName: "LABUBU: Fall In Wild",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Maya: Elemental Totem 2",
                        },
                        { provider: "jolliplay", gameName: "Big Net Bass" },
                        {
                          provider: "jolliplay",
                          gameName: "Disco 777 Hold and Win",
                        },
                        { provider: "jolliplay", gameName: "Sugar Crush" },
                        { provider: "jolliplay", gameName: "Piggy Bank Gold" },
                        {
                          provider: "jolliplay",
                          gameName: "Squid Game 2: Mukunghwa",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Leprechaun’s Fortune",
                        },
                        { provider: "jolliplay", gameName: "BlackJack 21" },
                        {
                          provider: "jolliplay",
                          gameName: "Pirate Treasure Hunt",
                        },
                        { provider: "jolliplay", gameName: "Cai Shen Fortune" },
                        {
                          provider: "jolliplay",
                          gameName: "Aztec: Gold Temple",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Crazy Bounty: Jackpot",
                        },
                        { provider: "jolliplay", gameName: "Rush Hour Gold" },
                        { provider: "jolliplay", gameName: "Buffalo Rush" },
                        {
                          provider: "jolliplay",
                          gameName: "Rhapsody of Muertos",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Phantom Multiplier",
                        },
                        { provider: "jolliplay", gameName: "Starry Adventure" },
                        {
                          provider: "jolliplay",
                          gameName: "Fish Prawn Crab Bonanza",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Aztec: Bonus Hunt 2",
                        },
                        { provider: "jolliplay", gameName: "Football Fever" },
                        { provider: "jolliplay", gameName: "Firefly Hunter" },
                        { provider: "jolliplay", gameName: "Dark Ritual" },
                        { provider: "jolliplay", gameName: "Hungry Slime" },
                        {
                          provider: "jolliplay",
                          gameName: "Maya: Elemental Totem",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Dragon Chi’s Quest",
                        },
                        { provider: "jolliplay", gameName: "Last Samurai" },
                        {
                          provider: "jolliplay",
                          gameName: "Squid Game 2：Mukunghwa",
                        },
                      ]}
                      rank="off"
                      limit={50}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                    <div className="promotion-tnc-cta">
                      <a
                        href="/slots/?provider=JOLLIPLAY"
                        className="promotion-cta-btn"
                      >
                        Play Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
